import { render, staticRenderFns } from "./PresentationsSection.v2.vue?vue&type=template&id=9da0834e&scoped=true&"
import script from "./PresentationsSection.v2.vue?vue&type=script&lang=js&"
export * from "./PresentationsSection.v2.vue?vue&type=script&lang=js&"
import style0 from "./PresentationsSection.v2.vue?vue&type=style&index=0&id=9da0834e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da0834e",
  null
  
)

export default component.exports